import { DialogActions } from '@mui/material'
import DialogTitle from '@mui/material/DialogTitle'
import React from 'react'
import { useTranslation } from 'react-i18next'
import ContainedButton from 'shared/components/Buttons/ContainedButton'
import OutlinedButton from 'shared/components/Buttons/OutlinedButton'
import CustomDialog from 'shared/components/CustomDialog'

interface Props {
   open: boolean
   onClose: () => void
   onSubmit: () => void
}

export default function CopyConfigModal({ open, onClose, onSubmit }: Props) {
   const { t } = useTranslation(['TRANSLATION', 'LOCATIONS'])

   return (
      <CustomDialog
         open={open}
         onClose={onClose}
         isLoading={!open}
         content={
            <>
               <DialogTitle>{t('LOCATIONS:favouriteProducers.modalTitle')}</DialogTitle>
               <DialogActions>
                  <OutlinedButton variant="outlined" onClick={onClose}>
                     {t('TRANSLATION:no')}
                  </OutlinedButton>
                  <ContainedButton variant="contained" onClick={onSubmit}>
                     {t('TRANSLATION:yes')}
                  </ContainedButton>
               </DialogActions>
            </>
         }
      />
   )
}
